export default __webpack_public_path__ + "static/media/139.25bfe905.gif";